import { Link, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { isAdminEmail } from '../adminEmails';
import ThemeToggle from './ThemeToggle';
import '../styles/Header.css';

export default function Header() {
  const { instance, accounts } = useMsal();
  const location = useLocation();
  const user = accounts[0]?.name || accounts[0]?.username || '';
  const email = accounts[0]?.username?.toLowerCase() || '';
  const isAdmin = isAdminEmail(email);

  const handleSignOut = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  return (
    <header className="header">
      <div className="header-brand">
        <img src="/LHF_logo.png" alt="Litehouse Foods" className="header-logo-img" />
        <span className="header-divider" />
        <span className="header-title">AI Wins</span>
      </div>
      <nav className="header-nav">
        <Link to="/submit" className={`nav-link ${location.pathname === '/submit' ? 'active' : ''}`}>
          Submit a Win
        </Link>
        <Link to="/wins" className={`nav-link ${location.pathname === '/wins' ? 'active' : ''}`}>
          View Wins
        </Link>
        {isAdmin && (
          <Link to="/admin" className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`}>
            Admin
          </Link>
        )}
        <a
          href="https://litehouseinc.sharepoint.com/sites/AIHQ#ready-to-use-copilot"
          target="_blank"
          rel="noreferrer"
          className="nav-link nav-link--copilot"
        >
          Ready to use Copilot?
        </a>
      </nav>
      <div className="header-user">
        <ThemeToggle />
        <span className="header-username">{user}</span>
        <button className="sign-out-btn" onClick={handleSignOut}>Sign Out</button>
      </div>
    </header>
  );
}
